import { BrandVM } from '../../common/view-model';
import { validateImage } from '../../helpers/validateImagesCanLoad';
const DEAFAULT_STATE: IBrandProfileState = {
	backToPageText: 'Back',
	missionStatementTitleText: 'Mission Statement',
	ourStoryTitleText: 'Our Story',
	contactTitleText: 'Contact',
	brandContactCardTitle: 'Brand Contact',
	brokerContactCardTitle: 'Broker Contact',
	contactBrandTitle: 'Contact Information'
};

interface IBrandProfileState {
	backToPageText: string;
	missionStatementTitleText: string;
	ourStoryTitleText: string;
	contactTitleText: string;
	brandContactCardTitle: string;
	brokerContactCardTitle: string;
	contactBrandTitle: string;
}
export const aboutBrandState = {
	...DEAFAULT_STATE
};
const validateNullability = (value: string | null | undefined): boolean => {
	return value !== null && value !== undefined && value !== '';
};

const validateClients = async (brand: any) => {
	const validated = await Promise.all(
		brand!.map(async (url: any) => {
			const isValid = await validateImage(url);
			return isValid ? url : null;
		})
	);
	return validated.filter(img => img !== null);
};
export const mapBrandAttributes = (brand: BrandVM): BrandVM => {
	return {
		...brand,
		hasContactInformation:
			(validateNullability(brand.contact_email) && validateNullability(brand.contact_phone)) ||
			validateNullability(brand.contact_name),
		hasBrokerContactInformation: brand.brokers && brand.brokers.length > 0,
		attributes: [
			{
				name: 'Headquarters',
				icon: 'ri-map-pin-line',
				content: `${brand.hq_city}${brand.hq_state ? ' , ' : ' '}${brand.hq_state}`,
				isLinkContent: false
			},
			{
				name: 'Founded Date',
				icon: 'ri-calendar-2-line',
				content: brand.brand_foundation_year,
				isLinkContent: false
			},
			{
				name: 'Distributors',
				icon: 'ri-truck-line',
				content: brand.distributors,
				isLinkContent: false
			},
			{
				name: 'Holding Company',
				icon: 'ri-organization-chart',
				content: brand.holding_company || 'None',
				isLinkContent: false
			},
			{
				name: 'Parent Company',
				icon: 'ri-parent-line',
				content: brand.parent_company || 'None',
				isLinkContent: false
			},
			{
				name: 'Brand Website',
				icon: 'ri-global-line',
				content: brand.brand_website,
				isLinkContent: true,
				linkText: 'Visit Site'
			},
			{
				name: 'Brand Video',
				icon: 'ri-live-line',
				content: brand.brand_video,
				isLinkContent: true,
				linkText: 'Watch Video'
			},
			{
				name: 'Youtube',
				icon: 'ri-youtube-line',
				content: brand.brand_youtube,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Instagram',
				icon: 'ri-instagram-line',
				content: brand.brand_instagram,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'TikTok',
				icon: 'ri-tiktok',
				content: brand.brand_tiktok,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Twitter',
				icon: 'ri-twitter-line',
				content: brand.brand_twitter,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Facebook',
				icon: 'ri-facebook-circle-line',
				content: brand.brand_facebook,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'LinkedIn',
				icon: 'ri-linkedin-fill',
				content: brand.brand_linkedin,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Private Label Available',
				icon: 'ri-price-tag-3-line',
				content: brand.uses_private_label ? 'Yes' : 'No',
				isLinkContent: false
			}
		]
	};
};

export interface BrandBusinessProviderI extends BrandVM {
	id: string;

	testimonial_1: string;

	testimonial_2: string;

	testimonial_3: string;

	author1_name: string;

	author1_company: string;

	author2_name: string;

	author2_company: string;

	author3_name: string;

	author3_company: string;

	certifications: string[];

	client_1_logo: string;

	client_2_logo: string;

	client_3_logo: string;

	client_4_logo: string;

	client_5_logo: string;

	main_service_1: string;

	main_service_2: string;

	main_service_3: string;

	main_service_4: string;

	main_service_5: string;

	reg_badge_number: string;

	services_logo: string;

	services_story: string;

	sp_collat_1: string;

	sp_collat_1_link: string;

	sp_collat_2: string;

	sp_collat_2_link: string;

	sp_contact_1_email: string;

	sp_contact_1_name: string;

	sp_contact_1_number: string;

	sp_contact_1_title: string;

	sp_contact_2_email: string;

	sp_contact_2_name: string;

	sp_contact_2_number: string;

	sp_contact_2_title: string;

	sp_contact_3_email: string;

	sp_contact_3_name: string;

	sp_contact_3_number: string;

	sp_contact_3_title: string;

	// Subcategories fields
	subcategories_1: string;

	subcategories_2: string;

	subcategories_3: string;

	subcategories_4: string;

	subcategories_5: string;
}

export const mapBrandProviderAttributes = async (
	brandProvider: any
): Promise<BrandBusinessProviderI> => {
	const brokersArray = [
		{
			name: brandProvider.sp_contact_1_name,
			email: brandProvider.sp_contact_1_email,
			role: brandProvider.sp_contact_1_title,
			phone: brandProvider.sp_contact_1_number
		},
		{
			name: brandProvider.sp_contact_2_name,
			email: brandProvider.sp_contact_2_email,
			role: brandProvider.sp_contact_2_title,
			phone: brandProvider.sp_contact_2_number
		},
		{
			name: brandProvider.sp_contact_3_name,
			email: brandProvider.sp_contact_3_email,
			role: brandProvider.sp_contact_3_title,
			phone: brandProvider.sp_contact_3_number
		}
	];
	const testimonialsArray = [
		{
			author: brandProvider.author1_name,
			description: brandProvider.testimonial_1,
			company: brandProvider.author1_company
		},
		{
			author: brandProvider.author2_name,
			description: brandProvider.testimonial_2,
			company: brandProvider.author2_company
		},
		{
			author: brandProvider.author3_name,
			description: brandProvider.testimonial_3,
			company: brandProvider.author3_company
		}
	];
	const offeringsArray = [
		{
			category: brandProvider.main_service_1,
			offers: brandProvider.subcategories_1?.split(';').slice(0, 5)
		},
		{
			category: brandProvider.main_service_2,
			offers: brandProvider.subcategories_2?.split(';').slice(0, 5)
		},
		{
			category: brandProvider.main_service_3,
			offers: brandProvider.subcategories_3?.split(';').slice(0, 5)
		},
		{
			category: brandProvider.main_service_4,
			offers: brandProvider.subcategories_4?.split(';').slice(0, 5)
		},
		{
			category: brandProvider.main_service_5,
			offers: brandProvider.subcategories_5?.split(';').slice(0, 5)
		}
	];
	const validTestimonials = testimonialsArray.filter(testimonial => {
		return testimonial.author && testimonial.description;
	});
	const validBrokers = brokersArray.filter(broker => {
		return broker.name && broker.email;
	});

	const validOfferings = offeringsArray.filter(offer => {
		return offer.category;
	});
	const clientImages = [
		brandProvider.client_1_logo,
		brandProvider.client_2_logo,
		brandProvider.client_3_logo,
		brandProvider.client_4_logo,
		brandProvider.client_5_logo
	];
	const validImages = await validateClients(clientImages);
	return {
		...brandProvider.common_data,
		brand_story: brandProvider.services_story,
		brokers: validBrokers,
		url_logo: brandProvider.services_logo,
		demo_link_1: {
			title: brandProvider.sp_collat_1,
			url: brandProvider.sp_collat_1_link
		},
		demo_link_2: {
			title: brandProvider.sp_collat_2,
			url: brandProvider.sp_collat_2_link
		},
		hasContactInformation:
			(validateNullability(brandProvider.common_data.contact_email) &&
				validateNullability(brandProvider.common_data.contact_phone)) ||
			validateNullability(brandProvider.common_data.contact_name),
		hasBrokerContactInformation: validBrokers.length > 0,
		hasProdRed:
			(validateNullability(brandProvider.common_data.productRepEmail) &&
				validateNullability(brandProvider.common_data.productRepPhone)) ||
			validateNullability(brandProvider.common_data.productRepName),
		attributes: [
			{
				name: 'Headquarters',
				icon: 'ri-map-pin-line',
				content: `${brandProvider.common_data.hq_city}${
					brandProvider.common_data.hq_state ? ' , ' : ' '
				}${brandProvider.common_data.hq_state}`,
				isLinkContent: false
			},
			{
				name: 'Founded Date',
				icon: 'ri-calendar-2-line',
				content: brandProvider.common_data.brand_foundation_year,
				isLinkContent: false
			},
			{
				name: 'Distributors',
				icon: 'ri-truck-line',
				content: brandProvider.common_data.distributors,
				isLinkContent: false
			},
			{
				name: 'Holding Company',
				icon: 'ri-organization-chart',
				content: brandProvider.common_data.holding_company || 'None',
				isLinkContent: false
			},
			{
				name: 'Parent Company',
				icon: 'ri-parent-line',
				content: brandProvider.common_data.parent_company || 'None',
				isLinkContent: false
			},
			{
				name: 'Brand Website',
				icon: 'ri-global-line',
				content: brandProvider.common_data.brand_website,
				isLinkContent: true,
				linkText: 'Visit Site'
			},
			{
				name: 'Brand Video',
				icon: 'ri-live-line',
				content: brandProvider.common_data.brand_video,
				isLinkContent: true,
				linkText: 'Watch Video'
			},
			{
				name: 'Youtube',
				icon: 'ri-youtube-line',
				content: brandProvider.common_data.brand_youtube,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Instagram',
				icon: 'ri-instagram-line',
				content: brandProvider.common_data.brand_instagram,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'TikTok',
				icon: 'ri-tiktok',
				content: brandProvider.common_data.brand_tiktok,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Twitter',
				icon: 'ri-twitter-line',
				content: brandProvider.common_data.brand_twitter,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Facebook',
				icon: 'ri-facebook-circle-line',
				content: brandProvider.common_data.brand_facebook,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'LinkedIn',
				icon: 'ri-linkedin-fill',
				content: brandProvider.common_data.brand_linkedin,
				isLinkContent: true,
				linkText: 'View Profile'
			},
			{
				name: 'Private Label Available',
				icon: 'ri-price-tag-3-line',
				content: brandProvider.common_data.uses_private_label ? 'Yes' : 'No',
				isLinkContent: false
			}
		],
		certifications: brandProvider.certifications,
		offerings: validOfferings,
		clients: validImages,
		testimonials: validTestimonials,
		brand_mission: ''
	};
};
